import { endOfDay, addDays } from "date-fns";

export default function endOfDuration(start: Date, length: number): Date {
  return endOfDay(addDays(start, length - 1));
}
